import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Table } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import Loading from "../../components/Common/Loading";

function Features(props) {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get features list
  const getFeatures = () => {
    setIsLoading(true);
    apiReq(url.GET_FEATURE, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setList(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getFeatures();
  }, []);

  // handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_FEATURE + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire("Deleted!", res.message, "success");
              getFeatures();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  const columns = [
    {
      title: "Image",
      render: (text, record, index) => (
        <span>
          <img src={record.image} alt={record.title} width="100" />
        </span>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Heading",
      dataIndex: "heading",
      key: "heading",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Sections",
      render: (text, record, index) => <span>{record.sections.length}</span>,
    },

    {
      title: "Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          <Link
            className="btn btn-success btn-sm mr-2"
            to={`/features/edit/${record._id}`}
          >
            <i className="ri-pencil-line"></i>
          </Link>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(record._id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Features</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <Link to="/features/create" className="btn btn-primary">
                      Add new feature
                    </Link>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={list}
                  bordered
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Features;
